import Swiper from 'swiper'

import {
  Autoplay,
  EffectFade,
  // FreeMode,
  Mousewheel,
  Navigation,
  Pagination,
  Thumbs,
} from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/mousewheel'
import 'swiper/css/effect-fade'

export default class Carousel {
  constructor(
    selector,
    options = {},
    container,
    captionSelector,
    global = false
  ) {
    const elements = container
      ? container.querySelectorAll(selector)
      : document.querySelectorAll(selector)

    const globalFooterCaptions =
      captionSelector && global
        ? document.querySelectorAll(captionSelector)
        : null

    elements.forEach((element) => {
      const footerCaptions =
        globalFooterCaptions || element.querySelectorAll(captionSelector)
      let opts = {
        ...options,
        on: {
          ...options.on, // Preserve any existing event handlers from options
        },
      }

      if (footerCaptions) {
        opts.on.slideChange = (swiper) => {
          // Update footer caption on slide change
          this.updateFooterCaption(swiper, footerCaptions)
          // Call original slideChange handler if it exists
          if (options.on?.slideChange) {
            options.on.slideChange(swiper)
          }
        }
      }

      if (!opts.navigation)
        opts.navigation = {
          nextEl: element.querySelector('.swiper-button.is-next'),
          prevEl: element.querySelector('.swiper-button.is-prev'),
        }

      const container = element.querySelector('.swiper-container')
      this.instance = new Swiper(container ? container : element, {
        modules: [
          Autoplay,
          Navigation,
          Pagination,
          Mousewheel,
          // FreeMode,
          EffectFade,
          Thumbs,
        ],
        mousewheel: {
          forceToAxis: true,
        },
        ...opts,
      })
    })
  }

  updateFooterCaption(swiper, footerCaptions) {
    const activeSlide = swiper.slides[swiper.activeIndex || 0]

    const hiddenCaption = activeSlide?.querySelector(
      '.swiper-caption.is-hidden'
    )

    if (hiddenCaption) {
      footerCaptions.forEach((footerCaption) => {
        footerCaption.innerHTML = hiddenCaption.innerHTML
      })
    }
  }
}
